import { OrganisationIdAndNameOnly } from '@/types/organisation';
import { findById } from '@/utils/find-by-id';
import { organisationIdAndNameOnly } from '@/utils/organisation-id-and-name-only';
import { useOrganisations } from './use-organisations';

export const useOrganisation = (id: number) => {
  const result = useOrganisations();

  const fullOrganisation = findById(result.data, id);

  // TODO: helper to convert organisation to id and name only
  const organisation: OrganisationIdAndNameOnly | undefined = fullOrganisation
    ? organisationIdAndNameOnly(fullOrganisation)
    : undefined;

  return { ...result, data: organisation };
};
